module.exports = __webpack_public_path__ + "img/Jackie Butler 1969.ffb15078.jpg";